'use strict';

import { base, Component, PropTypes, update, sub, fromJS, mq } from 'core';

import { Button, ButtonToolbar, ListGroup, ListGroupItem, Grid, Row, Col, Input, Panel } from 'react-bootstrap';

import { Link } from 'gui/components';

import $style from './style.styl';

const mqStateIcon = {
    'on': 'done',
    'off': 'off'
};

const mqStateStyle = {
    'on': { textShadow: '0 0 10px green' },
    'off': { textShadow: '0 0 10px red' }
};

@base({
    styles: [ $style ],
    track: [['mq', 'state']]
})
class Toolbar extends Component {

 	render() {

        const { state, edit, get } = this.props;

        const monitor = get('mq', 'state') || 'on';

  		return (
            <div className="toolbar">
                <div className="toolbar-tool">
                    <Link href="/app/"><span className="icon-home"></span></Link>
                </div>
                <hr/>
                <div className="toolbar-tool">
                    <Link href="/app/orders"><span className="icon-border_color"></span></Link>
                </div>
                <div className="toolbar-tool">
                    <Link href="/app/records"><span className="icon-record"></span></Link>
                </div>
                <div className="toolbar-tool">
                    <Link href="/app/cash"><span className="icon-list"></span></Link>
                </div>
                <hr/>
                <div className="toolbar-tool">
                    <Link href="/app/settings"><span className="icon-user-tie"></span></Link>
                </div>
                <div className="toolbar-tool">
                    <Link href="/app/manage"><span className="icon-area-chart"></span></Link>
                </div>

                <div className="toolbar-bottom">
                    <div className="toolbar-tool">
                        <span style={ mqStateStyle[monitor] }
                              className={`icon-cloud_${mqStateIcon[monitor]}`}/>
                    </div>
                </div>
            </div>
        );
	}
};

export default Toolbar



// WEBPACK FOOTER //
// ./ui/c/header/toolbar.jsx